export default __webpack_public_path__ + "static/media/higher_primary_hi_ident_reversed.5c38b84a.svg";